import { StoreOutlineIcon } from './StoreOutlineIcon';

/**
 * author: Google
 * id 6BF9FB77-DF50-40B5-9A93-43E2A22E8633
 * name store-outline
 * version: 4.9.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/store-outline.svg
 * tags
 * - Places 
 * - Shopping 
 */
export const ShopOutlineIcon = StoreOutlineIcon;
export default ShopOutlineIcon